import axios from 'axios';
import {
    PositionEmployeeRequest,
    PositionEmployee,
} from '../schemas/PositionEmployeeLog.schema';

export function retrievePositionEmployeeLog(params: PositionEmployeeRequest) {
    return axios.get<PositionEmployee>('/v1/log/position-employee', {
        params,
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('WF_APPLICATION')
        }
    });
}